import Cabecalho from "../../components/Cabecalho";
import { Outlet } from "react-router-dom";
import Rodape from "../../components/Rodape";
import styled from "styled-components";
import Banner from "./Banner";

const Container = styled.section`
  max-width: 100%;
  overflow-x: hidden;
`

export default function PaginaBase() {
    return (
        <Container>
        <Banner />
      
        
        </Container>
    )
}